import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = 100;

const zoomSlice = createSlice({
  name: "zoomLevel",
  initialState,
  reducers: {
    setZoomLevel: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setZoomLevel } = zoomSlice.actions;
export default zoomSlice.reducer;
